const MOJEID_STATUSES = {
	START: 'START',
	PENDING: 'PENDING',
	COMPLETE: 'COMPLETE',
	FAILURE: 'FAILURE'
};

export default MOJEID_STATUSES;
